import { useIntl } from 'react-intl';
import { ComposedTable } from 'components';
import {
  DEFAULT_COL_WIDTH,
  MIN_COL_WIDTH
} from 'pages/VendorsTablePage/components/VendorsTable/constants';
import { useAppSelector } from 'store/hooks';
import { pageHeader } from './messages';
import { ReviewChecksCustomTableHeader } from './ReviewChecksCustomTableHeader';
import { getSelectedVendors } from './slice';
import { PrintChecksVendorData, ReviewChecksTableProps } from './types';
import { useReviewChecksTableColDefs } from './useReviewChecksTableColDefs';

export const ReviewChecksTable = ({
  selectedCashCompany,
  selectedCashInBank,
  selectedJournal,
  postingDescription
}: ReviewChecksTableProps): React.JSX.Element => {
  const selectedVendors = useAppSelector(getSelectedVendors);
  const intl = useIntl();
  const columnDefs = useReviewChecksTableColDefs();

  const tableHeaderFilters = {
    cashCompany: selectedCashCompany?.label,
    cashAccount: selectedCashInBank?.label,
    cashDisbursementsJournal: selectedJournal?.label,
    postingDescription
  };

  return (
    <ComposedTable<PrintChecksVendorData>
      columnDefs={columnDefs}
      defaultColDef={{
        width: DEFAULT_COL_WIDTH,
        minWidth: MIN_COL_WIDTH
      }}
      getRowId={param => param.data.vendorNo}
      isDownloadable={false}
      isSearchable={false}
      isLoading={false}
      isPrintable={false}
      rowData={selectedVendors}
      useCustomHeader
      customHeaderContent={gridRef => (
        <ReviewChecksCustomTableHeader
          {...tableHeaderFilters}
          gridRef={gridRef}
        />
      )}
      tableHeaderTitle={intl.formatMessage(pageHeader.reviewChecks)}
      suppressRowClickSelection
      suppressRowDeselection
      tableHeaderCount={selectedVendors.length}
    />
  );
};
